
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#000","d":"M10.95 6.64l7.65 7.56v2.2h-2.2L7.84 7.75l2.11-2.11z"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","stroke":"#000","d":"M6.59 6.06l1.67-1.67a.308.308 0 01.44 0l1.53 1.53L8.12 8 6.59 6.5a.308.308 0 010-.44z"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M8.7 17.23a.27.27 0 00.3.27h5.41l-1.11-1.1H9a.27.27 0 00-.28.28l-.02.55zM9 14.2h2.14L10 13.1H9a.27.27 0 00-.28.28v.55a.272.272 0 00.28.27z"}}),_c('path',{attrs:{"fill":"#000","fill-opacity":".87","fill-rule":"nonzero","d":"M21.9 7.6h-6.84l1.11 1.1h5.73v11H2.1v-11h3.57l-.61-.62a2.938 2.938 0 01-.38-.48H2.1A1.1 1.1 0 001 8.7v11a1.1 1.1 0 001.1 1.1h19.8a1.1 1.1 0 001.1-1.1v-11a1.1 1.1 0 00-1.1-1.1z"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M5.67 17.78h.56a.28.28 0 00.27-.28V17a1.56 1.56 0 00.38-3l-1.55-.47A.45.45 0 015 13a.431.431 0 01.41-.45h1a.806.806 0 01.45.13c.1.08.24.08.34 0l.41-.38a.28.28 0 000-.39 2.002 2.002 0 00-1.08-.39v-.62c0-.15-.12-.27-.27-.27h-.59c-.15 0-.27.12-.27.27v.55A1.54 1.54 0 003.93 13 1.57 1.57 0 005 14.5l1.57.5a.45.45 0 01.3.44.431.431 0 01-.41.45h-1a.757.757 0 01-.44-.13.291.291 0 00-.35 0l-.41.38a.28.28 0 000 .39c.314.233.69.368 1.08.39v.56a.28.28 0 00.33.3z"}})])])
          )
        }
      }
    